export const APP_VERSION = "v3.3.0";
